import { useQuery } from "@apollo/client";
import { graphql } from "@/__generated__";

// Shown across the public app when a staff member is impersonating this user.
// Reads the session-scoped impersonation status and offers a one-click stop
// (native form POST so it works even if JS state is stale). Exported so the tour
// asks this same question, through the same cache entry, instead of a second one
// with its own selection (a partial write would replace this one's fields).
export const IMPERSONATION_QUERY = graphql(`
  query ImpersonationStatus {
    impersonation {
      active
      impersonatorEmail
    }
  }
`);

function csrfToken(): string {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") ?? "";
}

export default function ImpersonationBanner() {
  const { data } = useQuery(IMPERSONATION_QUERY, { fetchPolicy: "cache-and-network" });
  const impersonation = data?.impersonation;

  if (!impersonation?.active) return null;

  return (
    <div className="sticky top-0 z-[200] flex flex-wrap items-center justify-center gap-x-3 gap-y-1 bg-amber-500 px-4 py-2 text-center text-sm font-medium text-amber-950">
      <span>
        You are viewing Jynio as this user
        {impersonation.impersonatorEmail ? ` (admin: ${impersonation.impersonatorEmail})` : ""}. This impersonation is recorded.
      </span>
      <form method="post" action="/impersonation/stop" className="inline">
        <input type="hidden" name="authenticity_token" value={csrfToken()} />
        <button type="submit" className="font-semibold underline underline-offset-2 hover:no-underline">
          Stop impersonating
        </button>
      </form>
    </div>
  );
}
